(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bartolini-manifesto"] && !Shopify.designMode) return;
  try {
    
  class BCarosello extends HTMLElement {
    connectedCallback() {
      this.voci = Array.from(this.querySelectorAll('.b-carosello__voce'));
      if (!this.voci.length) return;
      this.indice = 0;
      // Prima cosa, sempre: si accende la prima foto. Finche' l'elemento non e' definito
      // la tiene accesa il CSS (`:not(:defined)`), ma da questo istante quella regola non
      // vale piu' — se si usciva di qui senza accenderla, spariva tutto.
      this.voci[0].classList.add('b-carosello__voce--attiva');
      if (this.voci.length < 2) return;
      const ritmo = Math.max(2, parseFloat(this.dataset.ritmo) || 4) * 1000;
      const fermo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (fermo) return;
      this.avvia = () => { this.timer = setInterval(() => this.avanti(), ritmo); };
      this.ferma = () => clearInterval(this.timer);
      this.addEventListener('mouseenter', this.ferma);
      this.addEventListener('mouseleave', this.avvia);
      this.avvia();
    }

    disconnectedCallback() {
      if (this.ferma) this.ferma();
    }

    avanti() {
      const prima = this.voci[this.indice];
      this.indice = (this.indice + 1) % this.voci.length;
      const dopo = this.voci[this.indice];
      // Le due si incrociano: una si spegne mentre l'altra si accende. Prima si spegneva
      // e basta, e per 450 millisecondi non c'era nessuna foto — un buco nero ogni giro.
      dopo.classList.remove('b-carosello__voce--via');
      dopo.classList.add('b-carosello__voce--attiva');
      prima.classList.remove('b-carosello__voce--attiva');
      prima.classList.add('b-carosello__voce--via');
    }
  }

  if (!customElements.get('b-carosello')) {
    customElements.define('b-carosello', BCarosello);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bartolini-popup-sconto"]) return;
  try {
    
  customElements.whenDefined('dialog-component').then(() => {
    document.querySelectorAll('.b-popup-sconto').forEach((el) => {
      const ritardo = parseInt(el.dataset.ritardo, 10) || 7000;
      setTimeout(() => {
        if (typeof el.showDialog === 'function') el.showDialog();
      }, ritardo);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bartolini-salvate"] && !Shopify.designMode) return;
  try {
    
  const CHIAVE = 'bartolini:salvate';

  function leggi() {
    try {
      const grezzo = window.localStorage.getItem(CHIAVE);
      return grezzo ? JSON.parse(grezzo) : [];
    } catch (e) {
      return [];
    }
  }

  function soldi(centesimi, valuta) {
    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: valuta || 'EUR',
        maximumFractionDigits: 0,
      }).format(centesimi / 100);
    } catch (e) {
      return '€ ' + Math.round(centesimi / 100);
    }
  }

  class MontatureSalvate extends HTMLElement {
    connectedCallback() {
      this.griglia = this.querySelector('.b-salvate__griglia');
      this.attesa = this.querySelector('.b-salvate__attesa');
      this.disegna();
      this.ascolta = () => this.disegna();
      document.addEventListener('bartolini:salvate', this.ascolta);
    }

    disconnectedCallback() {
      if (this.ascolta) document.removeEventListener('bartolini:salvate', this.ascolta);
    }

    async disegna() {
      const handles = leggi();
      if (handles.length === 0) return this.vuoto();

      // Una scheda che non esiste piu' (montatura tolta dal negozio) non deve rompere la
      // pagina: si scarta e basta.
      const schede = await Promise.all(
        handles.map((h) =>
          fetch('/products/' + encodeURIComponent(h) + '.js')
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      );

      const buone = schede.filter(Boolean);
      if (buone.length === 0) return this.vuoto();

      this.griglia.innerHTML = buone.map((p) => this.scheda(p)).join('');
      this.griglia.hidden = false;
      if (this.attesa) this.attesa.remove();
      const svuota = this.querySelector('.b-salvate__vuoto');
      if (svuota) svuota.remove();
    }

    scheda(p) {
      const foto = p.featured_image
        ? '<img src="' + p.featured_image + '&width=680" alt="" loading="lazy">'
        : '';
      const marca = p.vendor ? '<p class="b-salvata__marca">' + p.vendor + '</p>' : '';
      return (
        '<article class="b-salvata">' +
        '<a class="b-salvata__foto" href="' + p.url + '">' + foto + '</a>' +
        '<div class="b-salvata__riga"><div>' + marca +
        '<p class="b-salvata__nome"><a href="' + p.url + '">' + p.title + '</a></p></div>' +
        '<p class="b-salvata__prezzo">' + soldi(p.price, window.Shopify && window.Shopify.currency && window.Shopify.currency.active) + '</p>' +
        '</div>' +
        '<salva-montatura class="b-salva" data-handle="' + p.handle + '">' +
        '<button type="button" class="b-salva__tasto" aria-pressed="true" aria-label="Togli dai preferiti ' + p.title + '">' +
        '<svg class="b-salva__cuore" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path d="M12 20.4 3.9 12.6a5 5 0 0 1 7.1-7.05L12 6.5l1-.95a5 5 0 0 1 7.1 7.05Z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
        '</svg><span class="b-salva__parola"></span></button></salva-montatura>' +
        '</article>'
      );
    }

    vuoto() {
      this.griglia.hidden = true;
      this.griglia.innerHTML = '';
      if (this.attesa) this.attesa.remove();
      if (this.querySelector('.b-salvate__vuoto')) return;
      const d = document.createElement('div');
      d.className = 'b-salvate__vuoto';
      d.innerHTML =
        '<p>' + (this.dataset.vuotoTitolo || '') + '</p>' +
        '<a class="b-btn b-btn--vuoto" href="' + (this.dataset.vuotoUrl || '/collections') + '">' +
        (this.dataset.vuotoBottone || '') + '</a>';
      this.appendChild(d);
    }
  }

  if (!customElements.get('montature-salvate')) {
    customElements.define('montature-salvate', MontatureSalvate);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bartolini-servizi"] && !Shopify.designMode) return;
  try {
    
  class VoceFilmato extends HTMLElement {
    connectedCallback() {
      this.tasto = this.querySelector('.b-voce__tasto');
      // Il filmato e' il fratello precedente: il tasto vive dentro lo stesso riquadro.
      this.filmato = this.parentElement && this.parentElement.querySelector('video');
      if (!this.tasto || !this.filmato) {
        this.hidden = true;
        return;
      }
      this.tasto.addEventListener('click', () => this.cambia());
    }

    cambia() {
      const acceso = this.filmato.muted;
      this.filmato.muted = !acceso;
      // Se il browser aveva sospeso la riproduzione, l'click dell'utente la riabilita.
      if (acceso && this.filmato.paused) this.filmato.play().catch(() => {});
      this.tasto.setAttribute('aria-pressed', acceso ? 'true' : 'false');
      this.tasto.setAttribute('aria-label', acceso ? "Spegni l'audio" : "Accendi l'audio");
    }
  }

  if (!customElements.get('voce-filmato')) {
    customElements.define('voce-filmato', VoceFilmato);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
